import { FormControlLabel, Switch } from '@mui/material';
import { useTranslation } from 'next-i18next';
import React, { useState } from 'react';
import { usePermission } from '../../../hooks/usePermission';
import { useSelector } from '../../../reduxToolkit/typedRedux';
import StageSignupButton from '../../event/templates/TypeStage/StageSignupButton';
import PollControl from './PollControl';
import PollStage from './PollStage';

interface VyPollProps {
  allowUnregistered?: boolean;
  backgroundColor?: string;
  textColor?: string;
}

const VyPoll = ({ allowUnregistered = false, backgroundColor, textColor }: VyPollProps) => {
  const meeting = useSelector(({ video }) => video.meeting);
  const user = useSelector((state) => state.common.user);
  const event = useSelector((state) => state.common.event);

  const { isBoothHost, isEventHost } = usePermission();

  const { t } = useTranslation();

  const isUserBoothHost = (meeting && user && meeting.booth && isBoothHost(user, [meeting.booth])) === true;
  const isUserEventHost = (event && user && isEventHost()) === true;

  const [isAdminParticipating, setIsAdminParticipating] = useState(isUserBoothHost || isUserEventHost);

  function handleChangeAdminParticipating() {
    setIsAdminParticipating(!isAdminParticipating);
  }

  if (!user && !allowUnregistered) return <StageSignupButton />;

  return (
    <>
      {(isUserEventHost || isUserBoothHost) && (
        <FormControlLabel
          style={{ margin: 0 }}
          className="text-slate-800"
          control={<Switch defaultChecked={isAdminParticipating} onChange={handleChangeAdminParticipating} />}
          label={t('poll:is-admin-participating')}
        />
      )}
      <div className="h-full overflow-y-scroll">
        <PollStage isAdminParticipating={isAdminParticipating} allowUnregistered={allowUnregistered} backgroundColor={backgroundColor} textColor={textColor} />
        {!isAdminParticipating && <PollControl backgroundColor={backgroundColor} textColor={textColor} />}
      </div>
    </>
  );
};
export default VyPoll;
